import { BaseNode } from "../Node/BaseNode";
import { TreeNodeMedicinalProductsMAH } from "../Node/MedicinalProductsNode/ListEntity/TreeNodeMedicinalProductsMAH";
import { SimpleSearchNode } from "../Node/SimpleSearchNode";
import { MAHsQueryNode } from "../Node/MedicinalProductsNode/Query/MAHs/MAHsQueryNode";
import { Section } from "./Section";
import { SponsorQueryNode } from "../Node/MedicinalProductsNode/Query/Sponsor/SponsorQueryNode";
import { TreeNodeMedicinalProductsSponsor } from "../Node/MedicinalProductsNode/ListEntity/TreeNodeMedicinalProductsSponsor";
import { Art57Section } from "./Art57Section";
import { ConfirmationService } from "primeng/api";
import { environment } from "../../../../environments/environment";
import { SimpleSearchListNode } from "../Node/SimpleSearchListNode";
import { MedicinalProductsQueryResultNode } from "../Node/MedicinalProductsNode/MedicinalProductsQueryResultNode";
import { Art57NodeUtils } from "../Node/Art57Node/Art57NodeUtils";
import { MedicinalProductsQueryNode } from "../Node/MedicinalProductsNode/MedicinalProductsQueryNode";
import { ATCCodeQueryNode } from "../Node/MedicinalProductsNode/Query/ATC Code/ATCCodeQueryNode";
import { TreeNodeMedicinalProductsATCcode } from "../Node/MedicinalProductsNode/ListEntity/TreeNodeMedicinalProductsATCcode";
import { TreeNodeMedicinalProductsPharmaceuticalForm } from "../Node/MedicinalProductsNode/ListEntity/TreeNodeMedicinalProductsPharmaceuticalForm";
import { PharmaceuticalFormsQueryNode } from "../Node/MedicinalProductsNode/Query/PharmaceuticalForm/PharmaceuticalFormsQueryNode";
import { TreeNodeMedicinalProductsSource } from "../Node/MedicinalProductsNode/ListEntity/TreeNodeMedicinalProductsSource";
import { SourceQueryNode } from "../Node/MedicinalProductsNode/Query/Source/SourceQueryNode";
import { TreeNodeMedicinalProductsROA } from "../Node/MedicinalProductsNode/ListEntity/TreeNodeMedicinalProductsROA";
import { TreeNodeMedicinalProductsMFL } from "../Node/MedicinalProductsNode/ListEntity/TreeNodeMedicinalProductsMFL";
import { ROAQueryNode } from "../Node/MedicinalProductsNode/Query/ROA/ROAQueryNode";
import { TreeNodeMedicinalProductsAttachment } from "../Node/MedicinalProductsNode/ListEntity/TreeNodeMedicinalProductsAttachment";
import { AttachmentQueryNode } from "../Node/MedicinalProductsNode/Query/Attachment/AttachmentQueryNode";
import { MasterFileLocationQueryNode } from "../Node/MedicinalProductsNode/Query/MFL/MasterFileLocationQueryNode";
import { TreeNodeMedicinalProductsApprovedSubstance } from "../Node/MedicinalProductsNode/ListEntity/TreeNodeMedicinalProductsApprovedSubstance";
import { ApprovedSubstancesQueryNode } from "../Node/MedicinalProductsNode/Query/ApprovedSubstances/ApprovedSubstancesQueryNode";
import { TreeNodeMedicinalProductsDevelopmentSubstance } from "../Node/MedicinalProductsNode/ListEntity/TreeNodeMedicinalProductsDevelopmentSubstance";
import { TreeNodeMedicinalProductsAuthorisedProduct } from "../Node/MedicinalProductsNode/ListEntity/TreeNodeMedicinalProductsAuthorisedProduct";
import { DevelopmentSubstanceQueryNode } from "../Node/MedicinalProductsNode/Query/DevelopmentSubstances/DevelopmentSubstanceQueryNode";
import { TreeNodeMedicinalProductsDevelopmentProduct } from "../Node/MedicinalProductsNode/ListEntity/TreeNodeMedicinalProductsDevelopmentProduct";
import { AuthorisedProductsValidVersionQueryNode } from "../Node/MedicinalProductsNode/Query/AuthorisedProducts/AuthorisedProductsValidVersionQueryNode";
import { OwnedAuthorisedProductsQueryNode } from "../Node/MedicinalProductsNode/Query/AuthorisedProducts/OwnedAuthorisedProductsQueryNode";
import { OwnedDevelopmentProductsQueryNode } from "../Node/MedicinalProductsNode/Query/DevelopmentProducts/OwnedDevelopmentProductsQueryNode";
import { AuthService } from "../../service/auth-service/auth-service.service";
import { OwnedEVMPDEntitiesQueryNode } from "../Node/MedicinalProductsNode/Query/OwnedEVMPDEntities/OwnedEVMPDEntitiesQueryNode";
import { OwnedByEVMPDEntitiesQueryNode } from "../Node/MedicinalProductsNode/Query/OwnedEVMPDEntities/OwnedByEVMPDEntitiesQueryNode";
import { AuthorisedProductsLastVersionQueryNode } from "../Node/MedicinalProductsNode/Query/AuthorisedProducts/AuthorisedProductsLastVersionQueryNode";
import { TreeNodeMedicinalProductsAbstractCompositions } from "../Node/MedicinalProductsNode/ListEntity/TreeNodeMedicinalProductsAbstractCompositions";
import { SubstanceNamesQueryNode } from "../Node/MedicinalProductsNode/Query/SubstanceNames/SubstanceNamesQueryNode";
import { EntityEnum } from "../Node/EntityEnum";
import { AbstractCompositionQueryNode } from "../Node/MedicinalProductsNode/Query/AbstractComposition/AbstractCompositionQueryNode";
import { DevelopmentProductsLastVersionQueryNode } from "../Node/MedicinalProductsNode/Query/DevelopmentProducts/DevelopmentProductsLastVersionQueryNode";
import { DevelopmentProductsValidVersionQueryNode } from "../Node/MedicinalProductsNode/Query/DevelopmentProducts/DevelopmentProductsValidVersionQueryNode";
import { TreeNodeMedicinalProductsXevprmMessage } from "../Node/MedicinalProductsNode/ListEntity/TreeNodeMedicinalProductsXevprmMessage";
import { ValidationQueryNode } from "../Node/MedicinalProductsNode/Query/Validation/ValidationQueryNode";
import { XevprmMessageAutoUploadEntity } from "../Node/MedicinalProductsNode/Entity/XevprmMessageAutoUploadEntity";
import { query } from "@angular/animations";
import { MessageQueryNode } from "../Node/MedicinalProductsNode/Query/Message/MessageQueryNode";
import { AutoUploadNode } from "../Node/AutoUploadNode";

export class MedicinalProductSection extends Section {

    treeView: BaseNode[] = [];
    selectedNode!: BaseNode;

    authorisedProductTreeNode: BaseNode = new TreeNodeMedicinalProductsAuthorisedProduct(this.ioc, undefined, false);
    developmentProductTreeNode: BaseNode = new TreeNodeMedicinalProductsDevelopmentProduct(this.ioc, undefined, false);
    approvedSubstanceTreeNode: BaseNode = new TreeNodeMedicinalProductsApprovedSubstance(this.ioc, undefined, false);
    developmentSubstanceTreeNode: BaseNode = new TreeNodeMedicinalProductsDevelopmentSubstance(this.ioc, undefined, false);
    sourceTreeNode: BaseNode = new TreeNodeMedicinalProductsSource(this.ioc, undefined, false);
    mahsTreeNode: BaseNode = new TreeNodeMedicinalProductsMAH(this.ioc, undefined, false);
    sponsorTreeNode: BaseNode = new TreeNodeMedicinalProductsSponsor( this.ioc, undefined,false);
    atccodeTreeNode: BaseNode = new TreeNodeMedicinalProductsATCcode(this.ioc, undefined, false);
    roaTreeNode: BaseNode = new TreeNodeMedicinalProductsROA(this.ioc,undefined, false);
    pharmaceuticalFormTreeNode: BaseNode = new TreeNodeMedicinalProductsPharmaceuticalForm(this.ioc, undefined, false);
    masterfilelocationTreeNode: BaseNode = new TreeNodeMedicinalProductsMFL(this.ioc, undefined, false);
    attachmentTreeNode: BaseNode = new TreeNodeMedicinalProductsAttachment(this.ioc, undefined,false);
    xevprmMessageTreeNode: BaseNode = new TreeNodeMedicinalProductsXevprmMessage(this.ioc, undefined, false);
    abstractCompositionsTreeNode: BaseNode = new TreeNodeMedicinalProductsAbstractCompositions(this.ioc,undefined, false);

    isEmaOrganisation: boolean = this.ioc.get(AuthService).isEMAOrganisation();
    isNCAOrganisation: boolean = this.ioc.get(AuthService).isNCAOrganisation();

    override resetSection(): void {
      this.isEmaOrganisation = this.ioc.get(AuthService).isEMAOrganisation();
      this.isNCAOrganisation = this.ioc.get(AuthService).isNCAOrganisation();

    // Reset nodes
        this.authorisedProductTreeNode = new TreeNodeMedicinalProductsAuthorisedProduct(this.ioc, undefined,false);
        this.developmentProductTreeNode = new TreeNodeMedicinalProductsDevelopmentProduct(this.ioc, undefined,false);
        this.approvedSubstanceTreeNode = new TreeNodeMedicinalProductsApprovedSubstance(this.ioc, undefined,false);
        this.developmentSubstanceTreeNode = new TreeNodeMedicinalProductsDevelopmentSubstance(this.ioc, undefined,false);
        this.sourceTreeNode = new TreeNodeMedicinalProductsSource(this.ioc, undefined, false);
        this.mahsTreeNode = new TreeNodeMedicinalProductsMAH(this.ioc, undefined, false);
        this.sponsorTreeNode = new TreeNodeMedicinalProductsSponsor( this.ioc, undefined, false);
        this.atccodeTreeNode = new TreeNodeMedicinalProductsATCcode(this.ioc, undefined, false);
        this.roaTreeNode = new TreeNodeMedicinalProductsROA(this.ioc,undefined, false);
        this.pharmaceuticalFormTreeNode = new TreeNodeMedicinalProductsPharmaceuticalForm(this.ioc, undefined, false);
        this.masterfilelocationTreeNode = new TreeNodeMedicinalProductsMFL(this.ioc, undefined, false);
        this.attachmentTreeNode = new TreeNodeMedicinalProductsAttachment(this.ioc, undefined, false);
        if (this.isEmaOrganisation) {
          this.xevprmMessageTreeNode = new TreeNodeMedicinalProductsXevprmMessage(this.ioc, undefined, false);
        }
        this.abstractCompositionsTreeNode = new TreeNodeMedicinalProductsAbstractCompositions(this.ioc,undefined,false);

        // Queries node
        let queryTreeNode = new SimpleSearchNode(this.ioc,[],"Queries");
        queryTreeNode.children?.push(new OwnedEVMPDEntitiesQueryNode(this.ioc));
        this.isEmaOrganisation ? queryTreeNode.children?.push(new OwnedByEVMPDEntitiesQueryNode(this.ioc)) : '';
        this.isEmaOrganisation ? queryTreeNode.children?.push(new ValidationQueryNode(this.ioc)) : '';
        !this.isEmaOrganisation && !this.isNCAOrganisation ? queryTreeNode.children?.push(new OwnedAuthorisedProductsQueryNode(this.ioc)) : '';
        (this.isEmaOrganisation || this.isNCAOrganisation) ? queryTreeNode.children?.push(new AuthorisedProductsLastVersionQueryNode(this.ioc)) : '';
        queryTreeNode.children?.push(new AuthorisedProductsValidVersionQueryNode(this.ioc));
        this.isEmaOrganisation || this.isNCAOrganisation? queryTreeNode.children?.push(new DevelopmentProductsLastVersionQueryNode(this.ioc)) : '';
        this.isEmaOrganisation || this.isNCAOrganisation? queryTreeNode.children?.push(new DevelopmentProductsValidVersionQueryNode(this.ioc)) : '';
        !this.isEmaOrganisation && !this.isNCAOrganisation? queryTreeNode.children?.push(new OwnedDevelopmentProductsQueryNode(this.ioc)) : '';
        queryTreeNode.children?.push(new SubstanceNamesQueryNode(this.ioc, EntityEnum.substancesNames));
        queryTreeNode.children?.push(new SubstanceNamesQueryNode(this.ioc, EntityEnum.approvedSubstanceNames));
        queryTreeNode.children?.push(new SubstanceNamesQueryNode(this.ioc, EntityEnum.developmentSubstanceNames));
        queryTreeNode.children?.push(new ApprovedSubstancesQueryNode(this.ioc));
        queryTreeNode.children?.push(new DevelopmentSubstanceQueryNode(this.ioc));
        queryTreeNode.children?.push(new SourceQueryNode(this.ioc));
        queryTreeNode.children?.push(new MAHsQueryNode(this.ioc));
        queryTreeNode.children?.push(new SponsorQueryNode(this.ioc));
        queryTreeNode.children?.push(new ATCCodeQueryNode(this.ioc));
        queryTreeNode.children?.push(new ROAQueryNode(this.ioc));
        queryTreeNode.children?.push(new PharmaceuticalFormsQueryNode(this.ioc));
        this.isEmaOrganisation ? queryTreeNode.children?.push(new MessageQueryNode(this.ioc)) : '';
        queryTreeNode.children?.push(new AbstractCompositionQueryNode(this.ioc));
        queryTreeNode.children?.push(new AttachmentQueryNode(this.ioc));
        queryTreeNode.children?.push(new MasterFileLocationQueryNode(this.ioc));
        
        this.treeView = []; // force to clean structure if it has any nodes
        this.treeView.push(this.authorisedProductTreeNode);
        this.treeView.push(this.developmentProductTreeNode);
        this.treeView.push(this.approvedSubstanceTreeNode);
        this.treeView.push(this.developmentSubstanceTreeNode);
        this.treeView.push(this.sourceTreeNode);
        this.treeView.push(this.mahsTreeNode);
        this.treeView.push(this.sponsorTreeNode);
        this.treeView.push(this.atccodeTreeNode);
        this.treeView.push(this.roaTreeNode);
        this.treeView.push(this.pharmaceuticalFormTreeNode);   
        this.treeView.push(this.masterfilelocationTreeNode);  
        this.treeView.push(this.attachmentTreeNode); 
        if (this.isEmaOrganisation) {
          this.treeView.push(this.xevprmMessageTreeNode!);
        }  
        this.treeView.push(this.abstractCompositionsTreeNode);
         
        this.treeView.push(queryTreeNode);
        this.selectedNode = this.authorisedProductTreeNode;
    
    }

  public loadSelectedEntityNode(node: BaseNode){

      const model = this.getCheckedModels(node);
      if (model.length > 0) {
        this.injector.get(ConfirmationService).confirm({
          header: 'Message from webpage',
          message: `<span> Are you sure you want to load the selected item(s)?</span>`,
          icon: 'pi pi-question-circle',
          acceptLabel: 'Ok',
          rejectLabel: 'Cancel',
          accept: () => {
            const simpleSearchListNode = this.getTargetListNode(node);
            simpleSearchListNode.loadEntityNode(model);
          },
          reject: () => {
            // do nothing
          }
        });
      } else {
        this.injector!.get(Art57Section).showTooltipMessage({ severity: 'warn', detail: 'No Entity Checked', life: environment.errorElapsedTime });
      }
  }

  private getCheckedModels(node: BaseNode): any[] {
    if (node instanceof XevprmMessageAutoUploadEntity) {
      return node.checked ? [node.data.model] : [];
    }

    if (node instanceof SimpleSearchListNode && !node.showResults) {
      return node.children
        ?.filter(child => (child as BaseNode).checked)
        .map(child => child.data.model) ?? [];
    }

    return Array.isArray(node.data?.model)
      ? node.data.model.filter((model: any) => model.checked)
      : [];
  }

  private getTargetListNode(node: BaseNode): SimpleSearchListNode {
    if (node instanceof MedicinalProductsQueryResultNode) {
      return (Art57NodeUtils.findFirstParentNodeOfType(node, MedicinalProductsQueryNode) as MedicinalProductsQueryNode).entityNode! as SimpleSearchListNode;
    }

    if (node instanceof XevprmMessageAutoUploadEntity) {
      return this.xevprmMessageTreeNode as TreeNodeMedicinalProductsXevprmMessage;
    }

    if (node instanceof SimpleSearchListNode && node.parent instanceof XevprmMessageAutoUploadEntity) {
      const mainTreeNode = this.treeView.find(treeNode => treeNode.constructor === node.constructor);
      if (mainTreeNode) {
        return mainTreeNode as SimpleSearchListNode;
      }
    }

    return node as SimpleSearchListNode;
  }

  private checkLabelName() {
    let newNameLabel = this.injector!.get(Art57Section).getSelectedSection().selectedNode.labelNodeName;
    if(this.selectedNode.parent?.parent){
      newNameLabel = this.selectedNode.parent?.parent.label;
    }
    return newNameLabel;
  }

  public reinsertInfo(): Promise<boolean> {
    return new Promise((resolve) => {
      this.ioc.get(Art57Section).confirmationService.confirm({
        header: 'Information',
        message: 'The command  will prepare New ' + this.checkLabelName() + ' entity(ies) based on the currently selected ' + this.checkLabelName() + '. \n' + 
                 ' The existing ' + this.checkLabelName() + ' will not be affected.',
        icon: 'pi pi-question-circle',
        acceptLabel: 'Proceed',
        rejectLabel: 'Cancel',
        accept: () => {
          resolve(true);
        },
        reject: () => {
          resolve(false);
        }
      });
    });
   }

} 